import { render, staticRenderFns } from "./GoToManagerExerciseItem.vue?vue&type=template&id=3305bd3f&lang=pug&"
import script from "./GoToManagerExerciseItem.vue?vue&type=script&lang=ts&"
export * from "./GoToManagerExerciseItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports